import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './intervals-table.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  AVERAGE_BLOCK_TIME,
  STAKE_INTERVAL_STATUS,
} from '../../../../../../constants/blockchain-constants';
import * as labsUniStakeActions from '../../../../../../actions/labs-uni-stake-actions';
import Countdown from './timer';

const getStatus = (status) => {
  switch (status) {
    case STAKE_INTERVAL_STATUS.CURRENT:
      return <>Unlocked</>;
    case STAKE_INTERVAL_STATUS.COMPLETED:
      return <b>Completed</b>;
    default:
      return '';
  }
};

const getTimer = (lastBlockNumber, nextBlockNumber) => {
  const blockInSeconds = (nextBlockNumber - lastBlockNumber) * AVERAGE_BLOCK_TIME;
  const timestamp = Date.now() + blockInSeconds * 1e3;

  if (Number.isNaN(timestamp)) {
    return '';
  }

  return <Countdown date={new Date(timestamp)} />;
};

const IntervalsTable = ({ className }) => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.basic.dark);
  const { intervals } = useSelector((state) => state.LABSUNIstake.stake);
  const [lastBlockNumber, setLastBlockNumber] = useState();

  useEffect(() => {
    (async () => {
      const data = await dispatch(labsUniStakeActions.getLastIntervalBlockNumber());
      setLastBlockNumber(data);
    })();
  }, []);

  return (
    <div className={cn(styles.table, className, { [styles.dark]: dark })}>
      <div className={styles.tableDescription}>
        There are withdrawal fees when you unlock your staked tokens, based on the date you
        deposited your last tokens.
      </div>
      <div className={styles.tableBody}>
        <div className={styles.tableHeader}>Week</div>
        <div className={styles.tableHeader}>Unstake Fee</div>
        <div className={styles.tableHeader}>Status</div>
        {intervals?.map(({ index, percent, status, startBlockNumber }) => {
          return (
            <React.Fragment key={index}>
              <div className={styles.tableValue}>Week {index}</div>
              <div className={styles.tableValue}>{percent ? `${percent}%` : ''}</div>
              <div className={styles.tableValue}>
                {status === STAKE_INTERVAL_STATUS.NEXT
                  ? getTimer(lastBlockNumber, startBlockNumber)
                  : getStatus(status)}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

IntervalsTable.propTypes = {
  className: PropTypes.string,
};

IntervalsTable.defaultProps = {
  className: '',
};

export default IntervalsTable;
